import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
type FloatingCTAProps = {
  triggerRef: React.RefObject<HTMLElement>;
};
export function FloatingCTA({
  triggerRef
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = triggerRef.current;
      if (!el) return;
      setVisible(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [triggerRef]);
  return <AnimatePresence data-id="element-33" data-mp="2atqo02xae79k">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-navy/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-34" data-mp="38c0j7iwtemf8">
          <div className="mx-auto max-w-xl" data-id="element-35" data-mp="2pco3pqi9rqy5">
            <CTAButton label="Get Access — $27" shake className="!py-3.5" data-id="element-36" data-mp="2pbw5s9179h4p" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}